import React, { useEffect, useRef } from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog } from "../../components/dialog/dialogSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import AppDialog from "../../components/dialog/Dialog";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { Typography } from "@progress/kendo-react-common";
import { setDebitnoteVoucherBillDialogOpenIndex } from "./debitnoteVoucherSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { useLocation } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import { formatIndianNumber } from "../../_helper/helper";

const DebitnoteVoucherBillDetailsArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.debitnotevoucher.loading);
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const debit_note_voucher_guid = location.state?.debit_note_voucher_guid;
  const DebitnoteVoucherBillDialogOpenIndex = useAppSelector(
    (state) => state.debitnotevoucher.DebitnoteVoucherBillDialogOpenIndex
  );
  const DebitnoteVoucherDetail = useAppSelector(
    (state) => state.debitnotevoucher.DebitnoteVoucherDetail
  );

  useEffect(() => {
    const element = document.getElementsByName(
      `debit_note_voucher_bill_entry.0.referance_amount`
    );
    if (!loading) {
      if (element?.[0]) {
        setTimeout(() => {
          element?.[0]?.focus();
          if (debit_note_voucher_guid) {
            element?.[0]?.blur();
          }
        }, 1);
      }
    }
  }, [loading]);

  const handleCloseDialog = () => {
    dispatch(closeDialog());
    dispatch(setDebitnoteVoucherBillDialogOpenIndex(-1));
    const element = document.getElementById(
      `debit_note_voucher_entry.${
        DebitnoteVoucherBillDialogOpenIndex + 1
      }.debit_credit_id`
    );
    if (element) {
      setTimeout(() => {
        element.focus();
      }, 1);
    } else {
      const element = document.getElementById(`remarks_for_focus`);
      if (element) {
        setTimeout(() => {
          element.focus();
        }, 1);
      }
    }
  };

  const handleKeyEvent = (
    e: any,
    index: number,
    fieldArrayRenderProps: FieldArrayRenderProps
  ) => {
    const isremainingAmount0 =
      fieldArrayRenderProps.formRenderProps.valueGetter(
        "IndexDetails"
      )?.remainingAmount;

    let pendingAmount = 0;
    if (debit_note_voucher_guid) {
      pendingAmount =
        (fieldArrayRenderProps.value[index].final_pending_amount || 0) +
        (+DebitnoteVoucherDetail?.debit_note_voucher_entry?.[
          DebitnoteVoucherBillDialogOpenIndex
        ]?.debit_note_voucher_entry_referance.filter(
          (item: any) =>
            item.refernace_name ===
            fieldArrayRenderProps.formRenderProps.valueGetter(
              `debit_note_voucher_bill_entry.${index}.bill_no_string`
            )
        )?.[0]?.referance_amount || 0);
    } else {
      pendingAmount =
        fieldArrayRenderProps.value[index]?.final_pending_amount || 0;
    }

    const remainingAmount =
      (fieldArrayRenderProps.formRenderProps.valueGetter("IndexDetails")
        ?.remainingAmount || 0) +
      (fieldArrayRenderProps.value?.[index]?.referance_amount || 0);

    if (pendingAmount > remainingAmount) {
      fieldArrayRenderProps.formRenderProps.onChange(
        `debit_note_voucher_bill_entry.${index}.MaxAmount`,
        {
          value: +remainingAmount,
        }
      );
    } else {
      fieldArrayRenderProps.formRenderProps.onChange(
        `debit_note_voucher_bill_entry.${index}.MaxAmount`,
        {
          value: +pendingAmount,
        }
      );
    }

    if (e.key === "Tab" && isremainingAmount0 === 0) {
      if (!e.shiftKey) {
        dispatch(closeDialog());
        const element = document.getElementById(
          `debit_note_voucher_entry.${
            DebitnoteVoucherBillDialogOpenIndex + 1
          }.debit_credit_id`
        );
        if (element) {
          setTimeout(() => {
            element.focus();
          }, 1);
        } else {
          const element = document.getElementById(`remarks_for_focus`);
          if (element) {
            setTimeout(() => {
              element.focus();
            }, 1);
          }
        }
        dispatch(setDebitnoteVoucherBillDialogOpenIndex(-1));
      }
    }
  };

  const handleRefAmountChange = (
    e: any,
    index: number,
    fieldArrayRenderProps: FieldArrayRenderProps
  ) => {
    let pendingAmount = 0;
    if (debit_note_voucher_guid) {
      pendingAmount =
        (fieldArrayRenderProps.formRenderProps.valueGetter(
          `debit_note_voucher_bill_entry.${index}.final_pending_amount`
        ) || 0) +
        (+DebitnoteVoucherDetail?.debit_note_voucher_entry?.[
          DebitnoteVoucherBillDialogOpenIndex
        ]?.debit_note_voucher_entry_referance.filter(
          (item: any) =>
            item.refernace_name ===
            fieldArrayRenderProps.formRenderProps.valueGetter(
              `debit_note_voucher_bill_entry.${index}.bill_no_string`
            )
        )?.[0]?.referance_amount || 0);
    } else {
      pendingAmount =
        fieldArrayRenderProps.formRenderProps.valueGetter(
          `debit_note_voucher_bill_entry.${index}.final_pending_amount`
        ) || 0;
    }

    if (e.value === pendingAmount) {
      fieldArrayRenderProps.formRenderProps.onChange(
        `debit_note_voucher_bill_entry.${index}.isfullpayment`,
        { value: true }
      );
    } else {
      fieldArrayRenderProps.formRenderProps.onChange(
        `debit_note_voucher_bill_entry.${index}.isfullpayment`,
        { value: false }
      );
    }
  };
  const handleIsFullDebitnoteVoucher = (
    e: any,
    index: number,
    fieldArrayRenderProps: FieldArrayRenderProps
  ) => {
    if (e.value) {
      let pendingAmount = 0;
      if (debit_note_voucher_guid) {
        pendingAmount =
          (fieldArrayRenderProps.formRenderProps.valueGetter(
            `debit_note_voucher_bill_entry.${index}.final_pending_amount`
          ) || 0) +
          (+DebitnoteVoucherDetail?.debit_note_voucher_entry?.[
            DebitnoteVoucherBillDialogOpenIndex
          ]?.debit_note_voucher_entry_referance.filter(
            (item: any) =>
              item.refernace_name ===
              fieldArrayRenderProps.formRenderProps.valueGetter(
                `debit_note_voucher_bill_entry.${index}.bill_no_string`
              )
          )?.[0]?.referance_amount || 0);
      } else {
        pendingAmount =
          fieldArrayRenderProps.formRenderProps.valueGetter(
            `debit_note_voucher_bill_entry.${index}.final_pending_amount`
          ) || 0;
      }
      const remainingAmount =
        (fieldArrayRenderProps.formRenderProps.valueGetter("IndexDetails")
          ?.remainingAmount || 0) +
        (fieldArrayRenderProps.value?.[index]?.referance_amount || 0);

      if (remainingAmount >= pendingAmount) {
        fieldArrayRenderProps.formRenderProps.onChange(
          `debit_note_voucher_bill_entry.${index}.referance_amount`,
          { value: pendingAmount }
        );
      } else {
        fieldArrayRenderProps.formRenderProps.onChange(
          `debit_note_voucher_bill_entry.${index}.isfullpayment`,
          { value: false }
        );
      }
    } else {
      fieldArrayRenderProps.formRenderProps.onChange(
        `debit_note_voucher_bill_entry.${index}.referance_amount`,
        { value: 0 }
      );
    }
  };

  return (
    <>
      {dialogName === "DebitnoteVoucherBillItemDetailsDialog" && (
        <AppDialog className="journal-bill-dialog">
          <>
            <GridLayout
              cols={[
                {
                  width: "950px",
                },
              ]}
              style={{ padding: "10px" }}
            >
              <GridLayoutItem>
                <Typography.p className="m-0 text-center">
                  Bill-wise Details For :-{" "}
                  <b>
                    {fieldArrayRenderProps.formRenderProps
                      .valueGetter("IndexDetails")
                      ?.ledger_name?.toUpperCase()}
                  </b>
                </Typography.p>
                <Typography.p className="m-0 text-center">
                  Up to :-{" "}
                  <b>
                    ₹{" "}
                    {
                      fieldArrayRenderProps.formRenderProps.valueGetter(
                        "IndexDetails"
                      )?.amount
                    }{" "}
                    {fieldArrayRenderProps.formRenderProps.valueGetter(
                      "IndexDetails"
                    )?.debit_credit === "Debit"
                      ? "Dr"
                      : "Cr"}
                  </b>
                </Typography.p>
                <Typography.p
                  className=" text-center"
                  style={{ position: "relative" }}
                >
                  Remaining Amount :- ₹{" "}
                  <b>
                    {
                      fieldArrayRenderProps.formRenderProps.valueGetter(
                        "IndexDetails"
                      )?.remainingAmount
                    }{" "}
                    {fieldArrayRenderProps.formRenderProps.valueGetter(
                      "IndexDetails"
                    )?.debit_credit === "Debit"
                      ? "Dr"
                      : "Cr"}
                  </b>
                  {/* <button style={{visibility: "hidden", position: "absolute" }} id="use-me-for-focus">
                  Focus Button
                </button> */}
                </Typography.p>
              </GridLayoutItem>
            </GridLayout>
            <GridLayout
              cols={[{ width: "950px" }]}
              style={{
                maxHeight: "500px",
                overflowY: "scroll",
              }}
            >
              <GridLayoutItem
                className="bg-dark text-white fw-600"
                style={{
                  position: "sticky",
                  top: "0",
                  zIndex: "2",
                }}
              >
                <GridLayout
                  gap={{ rows: 10, cols: 0 }}
                  cols={[
                    { width: "8%" },
                    { width: "15%" },
                    { width: "15%" },
                    { width: "13%" },
                    { width: "14%" },
                    { width: "17%" },
                    { width: "15%" },
                    { width: "3%" },
                  ]}
                >
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Sr. No
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Bill No
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Bill Date
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Due Date
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Bill Amount
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Pending Amount
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  >
                    Amount
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{ padding: "5px 10px", border: "0.5px solid grey" }}
                  ></GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>
              {loading ? (
                <LoadingPanel gridRef={gridRef} />
              ) : (
                <>
                  {fieldArrayRenderProps.value &&
                    fieldArrayRenderProps.value.length > 0 &&
                    fieldArrayRenderProps.value.map(
                      (debit_note_voucher_bill_entry: any, index: number) => (
                        <GridLayoutItem
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 1 ? "#f4f1f1" : "#f9fdf9",
                          }}
                        >
                          <GridLayout
                            style={{
                              padding: "5px 0",
                            }}
                            gap={{ rows: 10, cols: 0 }}
                            cols={[
                              { width: "8%" },
                              { width: "15%" },
                              { width: "15%" },
                              { width: "13%" },
                              { width: "14%" },
                              { width: "17%" },
                              { width: "15%" },
                              { width: "3%" },
                            ]}
                          >
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {index + 1}
                            </GridLayoutItem>
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {debit_note_voucher_bill_entry?.bill_no_string}
                            </GridLayoutItem>
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {debit_note_voucher_bill_entry?.invoice_date}
                            </GridLayoutItem>
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {debit_note_voucher_bill_entry?.due_date}
                            </GridLayoutItem>
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                                padding: "5px 10px",
                              }}
                            >
                              {formatIndianNumber(
                                debit_note_voucher_bill_entry?.total_amount
                              ) || 0}
                            </GridLayoutItem>
                            <GridLayoutItem
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                                padding: "5px 15px",
                              }}
                            >
                              {formatIndianNumber(
                                debit_note_voucher_bill_entry?.final_pending_amount
                              ) || 0}
                            </GridLayoutItem>
                            <GridLayoutItem>
                              <Field
                                wrapperClassName="right-alighned-field"
                                wrapperStyle={{ margin: 0, padding: "5px" }}
                                name={`debit_note_voucher_bill_entry.${index}.referance_amount`}
                                placeholder="0"
                                format="n2"
                                max={
                                  +fieldArrayRenderProps.formRenderProps.valueGetter(
                                    `debit_note_voucher_bill_entry.${index}.MaxAmount`
                                  )
                                }
                                onChange={(e: any) =>
                                  handleRefAmountChange(
                                    e,
                                    index,
                                    fieldArrayRenderProps
                                  )
                                }
                                component={FormNumericTextField}
                                onKeyDown={(e: any) =>
                                  handleKeyEvent(
                                    e,
                                    index,
                                    fieldArrayRenderProps
                                  )
                                }
                              />
                            </GridLayoutItem>
                            <GridLayoutItem>
                              <Field
                                wrapperClassName="right-alighned-field"
                                wrapperStyle={{
                                  margin: "0px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  borderRadius: "5px",
                                }}
                                tabIndex={-1}
                                size="large"
                                style={{
                                  border: "1px solid #ccc",
                                }}
                                onChange={(e: any) =>
                                  handleIsFullDebitnoteVoucher(
                                    e,
                                    index,
                                    fieldArrayRenderProps
                                  )
                                }
                                name={`debit_note_voucher_bill_entry.${index}.isfullpayment`}
                                component={FormCheckbox}
                              />
                            </GridLayoutItem>
                          </GridLayout>
                        </GridLayoutItem>
                      )
                    )}
                </>
              )}
            </GridLayout>
            <GridLayout
              cols={[{ width: "950px" }]}
              style={{
                position: "absolute",
                bottom: "15px",
              }}
            >
              <GridLayoutItem>
                <GridLayout cols={[{ width: "950px" }]}>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: "10px",
                    }}
                  >
                    <Button
                      themeColor={"primary"}
                      fillMode={"outline"}
                      onClick={handleCloseDialog}
                      className="dialog-close-btn-entry"
                    >
                      Close
                    </Button>
                    {/* // <DialogCloseButton themeColor="error" /> */}
                  </GridLayoutItem>
                </GridLayout>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default DebitnoteVoucherBillDetailsArray;
